import { useEffect, useState } from 'react'
import { useRequest, useView } from '@10000/react'
import { Body, Box, H3 } from '../../widgets'
import { Recap } from './Recap.jsx'
import { useBackground, useShell, useStack } from '../../layout'
import { SquizButton, usePracticeWheel } from '../common'

export const Splash = ({ active, displayMode }) => {
  const { replaceStack } = useStack()
  const { presenter, options: { kiosk } = {} } = useView('squiz')
  const request = useRequest('squiz')
  const [timeoutHandle, setTimeoutHandle] = useState()

  useShell({ active, mode: 'logo' })
  useBackground().set({ active, background: null })
  usePracticeWheel().hide()

  useEffect(() => {
    const handle = setTimeout(() => replaceStack(Recap, { props: { displayMode } }), 2000)
    setTimeoutHandle(handle)
    return () => clearTimeout(handle)
  }, [replaceStack, displayMode])

  const showAnalytics = () => {
    clearTimeout(timeoutHandle)
    return request('analyticsStarted')
  }

  return (
    <Box
      fullHeight
      fullWidth
      background="var(--blue)"
    >
      <Box
        fullHeight
        fullWidth
        alignItems="center"
        justifyContent="center"
        background="linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)"
      >
        <Box column gap={32}>
          <H3 align="center">
            Your Squiz<br/>has ended
          </H3>
          <Body alt bold align="center">
            Let&apos;s see how we did...
          </Body>
        </Box>

        {presenter && !displayMode && !kiosk &&
          <Box position="absolute" bottom={40} px={32} fullWidth maxWidth={400}>
            <SquizButton
              onClick={showAnalytics}
              text="Skip and go to analytics"
            />
          </Box>
        }
      </Box>
    </Box>
  )
}